import DashboardSummaryKeyModal from "./DashboardSummaryKeyModal";

export default DashboardSummaryKeyModal;